import { useState } from "react";
import axios from "axios";
import { Lock, Inbox, Loader2 } from "lucide-react";
import { BRAND } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState("");
  const [authed, setAuthed] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/contact/submissions`, { headers: { "X-Admin-Key": key } });
      setRows(res.data);
      setAuthed(true);
    } catch (err) {
      setError(err?.response?.status === 401 ? "Invalid admin key." : "Failed to load submissions.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gk-black text-white py-16 px-6">
      <div className="mx-auto max-w-5xl">
        <div className="flex items-center gap-3 mb-10">
          <img src={BRAND.logo} alt="logo" className="w-10 h-10 rounded-lg object-cover ring-1 ring-gk-gold/30" />
          <div>
            <h1 className="font-cinzel text-2xl text-gold-metallic tracking-wider">GK BRANDIFY</h1>
            <p className="font-inter text-xs tracking-[0.3em] uppercase text-white/40">Enquiries Admin</p>
          </div>
        </div>

        {!authed ? (
          <form onSubmit={load} className="glass-strong rounded-2xl p-8 max-w-md">
            <div className="flex items-center gap-2 text-gk-champagne mb-6"><Lock size={18} /><span className="font-inter text-sm tracking-wide uppercase">Restricted</span></div>
            <label className="font-inter text-xs uppercase tracking-widest text-white/40">Admin Key</label>
            <input
              data-testid="admin-key-input"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Enter admin key"
              className="w-full bg-transparent border-b border-white/15 py-3 font-inter text-white focus:border-gk-gold transition-colors mb-6"
            />
            {error && <p className="text-red-400 text-sm mb-4">{error}</p>}
            <button data-testid="admin-login" type="submit" disabled={loading} className="btn-gold w-full py-3 rounded-full font-inter font-medium inline-flex items-center justify-center gap-2">
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Unlock"}
            </button>
          </form>
        ) : (
          <div>
            <div className="flex items-center gap-2 mb-6 text-white/60">
              <Inbox size={18} className="text-gk-gold" />
              <span className="font-inter text-sm">{rows.length} enquir{rows.length === 1 ? "y" : "ies"}</span>
            </div>
            {rows.length === 0 ? (
              <p className="font-poppins text-white/40">No submissions yet.</p>
            ) : (
              <div className="space-y-4">
                {rows.map((r) => (
                  <div key={r.id} data-testid="admin-row" className="glass rounded-2xl p-6">
                    <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                      <h3 className="font-cinzel text-xl text-gk-champagne">{r.name}</h3>
                      <span className="font-inter text-xs text-white/40">{new Date(r.created_at).toLocaleString()}</span>
                    </div>
                    <div className="grid sm:grid-cols-2 gap-x-8 gap-y-1 font-poppins text-sm text-white/70 mb-3">
                      <p><span className="text-white/40">Phone:</span> {r.phone}</p>
                      <p><span className="text-white/40">Email:</span> {r.email}</p>
                      <p><span className="text-white/40">Business:</span> {r.business || "—"}</p>
                      <p><span className="text-white/40">Budget:</span> {r.budget || "—"}</p>
                    </div>
                    <p className="font-poppins text-white/80 leading-relaxed border-t border-white/10 pt-3">{r.details}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
